class TextWithIcons extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector("[data-slider]");
    this.controls = this.querySelectorAll("[data-control]");

    this.slides = this.querySelectorAll(".splide__slide");
    // if (window.innerWidth >= 990 && this.slides.length < 5) {
    //   this.querySelector(".products-carousel__head").classList.add('hidden');
    // }
 
    this.controls.forEach((control) => {
      control.addEventListener("click", this.onControlClick.bind(this));
    });

    if (this.sliderElement.hasAttribute('data-destroy')) {
      this.slider.destroy(true);
    }

    if (this.sliderElement) {
      this.slider = new Splide(this.sliderElement, {
        pagination: false,
        waitForTransition: false,
        arrows: false,
        perPage: 4,
        perMove: 1,
        breakpoints: {
          990: {
            perPage: 2,
          },
        },
      }).mount();
    }
  }

  onControlClick(event) {
    event.preventDefault();

    if (!this.slider) {
      return;
    }

    const action = event.target.hasAttribute("data-prev") ? "<" : ">";

    this.slider.go(action);
  }
}

customElements.define('text-with-icons-carousel', TextWithIcons);
